import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild
} from '@angular/core';
import {Subscription, timer} from 'rxjs';
import {switchMap, tap} from 'rxjs/operators';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observation, PreviewsCollection, StickyPopover} from 'asax-common';
import {CellPreviewsService} from '../cell-previews.service';
import {AsaxPropertiesService} from 'asax-properties';

const delay = 300;

@Component({
  selector: 'asax-result-table-cell-previews-container',
  templateUrl: './cell-previews-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellPreviewsContainerComponent {
  @ViewChild('cartaModalTemplate', {static: true}) cartaModalTemplate: ElementRef;
  @ViewChild('stickyPopover', {static: true}) stickyPopover: StickyPopover;

  @Input() row: Observation;

  private timerSubscription: Subscription;

  isLoading: boolean;
  previewsCollections: PreviewsCollection[];
  cartaSocketUrl: string;

  constructor(public readonly asaxPropertiesService: AsaxPropertiesService,
              private readonly cellPreviewsService: CellPreviewsService,
              private readonly modalService: NgbModal,
              private readonly ref: ChangeDetectorRef) {
  }

  openFileInANewTab(file: string): void {
    const dataPortalUrl = this.asaxPropertiesService.getProperties().dataPortalUrl;
    window.open(`${dataPortalUrl}/${file}`, '_blank');
  }

  getFile(thumbnailFile: any): string {
    return this.cellPreviewsService.getFile(thumbnailFile);
  }

  centerModalAndSetTheCorrectWidth() {
    const modalDialog = document.querySelector('div[role="document"].modal-dialog') as HTMLElement;
    const modalContent = document.querySelector('.modal-dialog .modal-content') as HTMLElement;

    if (modalDialog) {
        // Reset classes to avoid using a lot of !important for the style and set all the important properties bellow
        modalDialog.className = ''; 
        Object.assign(modalDialog.style, {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'auto',
            margin: '1.75rem auto',
        });
    }

    if (modalContent) {
      modalContent.style.width = '1185px';
    }
  }

  openCartaModal(file: string): void {
    this.stickyPopover?.close();

    this.cartaSocketUrl = undefined;
    this.modalService.open(this.cartaModalTemplate);

    this.centerModalAndSetTheCorrectWidth();

    this.cellPreviewsService.fetchCartaSocketUrl(file).pipe(
      tap(cartaSocketUrl => this.cartaSocketUrl = cartaSocketUrl)
    ).subscribe();
  }

  openCartaInANewTab(): void {
    window.open(`${this.cartaSocketUrl}`, '_blank');
  }

  private fetchPreviewsCollections(): void {
    this.timerSubscription = timer(delay).pipe(
      tap(() => this.isLoading = true),
      tap(() => this.ref.markForCheck()),
      switchMap(() => this.cellPreviewsService.fetchPreviewsCollectionsForObservation(this.row.datasetId)),
      tap((previewsCollections: PreviewsCollection[]) => this.previewsCollections = previewsCollections),
      tap(() => this.isLoading = false),
      tap(() => this.ref.markForCheck()),
      tap(() => this.loadPreviewsThumbnails())
    ).subscribe();
  }

  private loadPreviewsThumbnails(): void {
    this.previewsCollections
      .map(previewCollection => previewCollection.previews)
      .flat()
      .map(preview => preview.thumbnailFile)
      .filter(thumbnailFile => !!thumbnailFile)
      .forEach(thumbnailFile => this.cellPreviewsService.loadFile(thumbnailFile));
  }

  @HostListener('mouseenter')
  private onMouseEnter(): void {
    this.fetchPreviewsCollections();
  }

  @HostListener('mouseleave')
  private onMouseLeave(): void {
    this.timerSubscription?.unsubscribe();
  }
}
